<template>
  <button
    class="flex w-full flex-col gap-1 squircle-lg rounded border p-2"
    :class="{
      'border-primary bg-primary-50 shadow': selected
    }"
    @click="
      !isDisabled && wikiItem.item_wiki_item_id
        ? $emit('click', wikiItem.id)
        : null
    "
  >
    <div class="flex flex-row items-center gap-2">
      <h3
        class="flex flex-1 flex-col truncate text-left text-base leading-none font-semibold"
      >
        <div :class="{ 'cursor-not-allowed text-gray-400': isDisabled }">
          {{ wikiItem.name[$i18n.locale] }}
        </div>

        <div v-if="!wikiItem.item_wiki_item_id" class="mt-1 flex gap-x-1">
          <BaseButton
            icon="link"
            inverse-icon-order
            size="extra-small"
            :title="$t('global.link_to_intern_item')"
            @click="linkInternalArticle()"
          />
        </div>
      </h3>
      <div
        :class="{ 'cursor-not-allowed text-gray-400': isDisabled }"
        class="shrink-0"
      >
        <span class="rounded border px-1.5 py-0">1x</span>
      </div>
    </div>

    <WikiItemPrices
      :wiki-item="wikiItem"
      :class="{ 'cursor-not-allowed': isDisabled }"
    />

    <div
      v-if="alreadyInInvoice && wikiItem.invoice_items_in_invoice?.length"
      class="mt-1 flex flex-row gap-2"
    >
      <span
        v-for="invoiceItem in wikiItem.invoice_items_in_invoice"
        :key="invoiceItem.id"
        class="rounded bg-primary px-1 py-0.5 text-xs text-contrast-primary"
      >
        {{
          invoiceItem.invoice.reference ??
          $t('global.doc_type_to_be_validated', {
            doc_type: $t('attributes.invoice')
          })
        }}
      </span>
    </div>
  </button>
  <ItemForWikiLinkModal
    v-if="openItemsModal"
    v-model="selectedItem"
    :open="openItemsModal"
    :display-pack-tab="false"
    @close="openItemsModal = false"
    @item-selected="linkWikiItemToItem"
  />
</template>

<script>
import WikiItemPrices from '@c/Wiki/WikiItemPrices.vue'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'
import ItemByCategoryModal from '@ui/modal/item/ItemByCategoryModal.vue'
import ItemForWikiLinkModal from '@/views/invoicing/show/tabs/automation/component/ItemForWikiItemLinkModal.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ItemWikiCard',
  components: {
    WikiItemPrices,
    ItemForWikiLinkModal,
    ItemByCategoryModal,
    BaseButton
  },
  props: {
    wikiItem: { type: Object, required: true },
    selected: { type: Boolean, default: false }
  },
  emits: ['click', 'refresh-wiki-items'],
  data() {
    return {
      openItemsModal: false,
      selectedItem: null
    }
  },
  computed: {
    ...mapGetters({
      invoice: 'invoicing/getInvoice'
    }),
    isDisabled() {
      return (
        this.wikiItem.item_wiki_item_id === null ||
        this.wikiAlreadyInInvoice?.includes(this.wikiItem.id)
      )
    },
    wikiAlreadyInInvoice() {
      return (
        this.invoice?.invoice_items?.map(
          (invoice_item) => invoice_item.wiki_item_id
        ) ?? []
      )
    }
  },
  methods: {
    ...mapActions({
      processLinkWikiItemToItemAction: 'item/linkWikiItemToItem'
    }),
    linkWikiItemToItem(item) {
      this.processLinkWikiItemToItemAction({
        item_id: item.id,
        wiki_item_id: this.wikiItem.id
      }).then((response) => {
        this.$h.toastSuccess(this.$t('toasts.link_item_success'))
        this.$emit('refresh-wiki-items')
        this.openItemsModal = false
      })
    },
    linkInternalArticle() {
      this.openItemsModal = true
    }
  }
}
</script>
